<template>
    <div class="site-main mt20">
    	<div class="art-detail" v-if="isArticle">
    	<div class="detail-content b-shadow">
    		<div class="hd">
    			<h3>{{art_data.post_title}}</h3>
    			<div class="info"><span><i class="iconfont icon-cate"></i>{{art_data.category_name}}</span><span><i class="iconfont icon-time"></i>{{formateTime(art_data.published_time)}}</span><span><i class="iconfont icon-read"></i>{{art_data.post_hits}}</span>
					<span class="type" v-if="art_data.article_type != '默认'">{{art_data.article_type}}</span>
				</div>
    		</div>
    		<div class="bd">
    			<div class="text-contet" v-html="art_data.post_content==''?art_data.post_excerpt:art_data.post_content">
    			</div>
    			<div v-if="isart_data">
    				<div class="art-label" v-if="art_data.tag.length!=0">标签：<span v-for="tag in art_data.tag" :key="tag.id">{{tag.name}}</span></div>
    			</div>
    			<div class="statement">郑重声明：本站原创文章为作者独立观点，不代表和数传媒立场；转载文章版权归原作者所有，如信息标记有误，请联系我们进行修改或删除，感谢关注。</div>
    		</div>
    	</div>
		<div class="comments" v-if="comment_data.length != 0">
			<ul class="c-list">
				<li class="c-item box" v-for="item in comment_data">
					<div class="col-1"><img src="../common/images/user-hd.png" alt=""></div>
					<div class="col-2 flex-1">
						<p class="user-name" v-if="item.user_nickname != ''">{{item.user_nickname}}</p>
						<p class="user-name" v-else>{{fmtMobile(item.mobile)}}</p>
						<p class="c-conten">{{item.content}}</p>
						<p class="c-date">{{formateTime(item.create_time)}}</p>
					</div>
				</li>
			</ul>
		</div>
		<div class="share-bar box align-center">
			<span class="text">分享：</span>
			<span class="wx-icon-img icon-img" @click="isShareTip=true"><img src="../common/images/weixin-icon.svg" alt="微信分享"></span>
			<span class="pyq-icon-img icon-img" @click="isShareTip=true"><img src="../common/images/pyq-icon.svg" alt="朋友圈分享"></span>
		</div>
		<div class="share-tip-layer" v-show="isShareTip" @click="isShareTip=false">
			<img src="../common/images/share-tip.svg" alt="">
		</div>
		<div class="comment-submit">
			<form method="post" @submit.prevent="onSubmit()">
				<div class="input-group box align-center">
					<div class="input-control flex-1 box align-center">
						<i class="iconfont">&#xe72e;</i>
						<input type="text" class="flex-1" :placeholder="comment_text" v-model.trim="comment">
					</div>
					<input type="submit" value="发表" class="sub-btn">
				</div>
				<router-link :to="{name:'loginView',params:{from:'detail'}}" tag="div" class="login-btn" v-if="loginState == false"></router-link>
			</form>
		</div>
		<tip :msgControl="msgShow"><p slot="content">{{tipText}}</p></tip>
    	<div class="new-article b-shadow mt20">
    		<div class="hd">
    			<h3><i class="icon"></i>最新推荐</h3>
    		</div>
    		<div class="bd">
    			<ul class="article-list clearfix">
    				<li class="article-item l" v-for="item in art_data.recommended_list" :key="item.id">
    					<router-link :to='{detail_type:"mobile",name:"detailView",params:{cid: item.category_id,id:item.id}}'>
    						<div class="img-box"><img :src="resourceUrl+item.thumbnail" :alt="item.post_title"></div>
    						<div class="text-box">
								<h3 class="tit">{{item.post_title}}</h3>
							</div>
    					</router-link>
    				</li>
    			</ul>
    		</div>
    	</div>
    </div>
    <div class="notArticle" v-else>
    	该文章不存在或已被删除
    </div>
    </div>
</template>

<script>
import {httpHead,apiUrl,resourceUrl,setSEO,getCookie} from '../common/util/config.js';
import wx from 'weixin-js-sdk'
import tip from '../components/tip.vue'
export default {
    data () {
        return {
			art_data: {},
			comment_data: [],
        	cate_id: 0,
        	article_id: 0,
        	resourceUrl,
        	pageSeo: {},
			link: '',
			mobile: '',
			token: '',
			comment: '',
			msgShow: false,
			tipText: '',
			loginState: false,
			comment_text: '请登录后再评论',
			isArticle: true,
			isShareTip: false, //分享提示
			isart_data:false
        }
    },
    created () {
		let cookie = document.cookie;
		this.mobile = getCookie(cookie,'mobile');
		this.token = getCookie(cookie,'token');
		if(this.mobile != undefined || this.token != undefined){
			this.loginState = true;
			this.comment_text = '写评论';
			httpHead.token = this.token;
		}
    	this.cate_id = this.$route.params.cid
		this.article_id = this.$route.params.id
		this.wxShare();
		this.getData();
		this.getComment();
		wx.ready(() => {
			wx.onMenuShareAppMessage({
				title: this.art_data.post_title, // 分享标题
				link: this.link, // 分享链接,将当前登录用户转为puid,以便于发展下线
				desc: this.art_data.post_excerpt,
				imgUrl: resourceUrl+this.art_data.thumbnail, // 分享图标
				success: function () { 
				  // 用户确认分享后执行的回调函数
				  //alert('分享成功');
				},
				cancel: function () { 
				  // 用户取消分享后执行的回调函数
				}
			});
			  //朋友圈
			wx.onMenuShareTimeline({
				title: this.art_data.post_title, // 分享标题
				link: this.link, // 分享链接,将当前登录用户转为puid,以便于发展下线
				imgUrl: resourceUrl+this.art_data.thumbnail, // 分享图标
				success: function () { 
				  // 用户确认分享后执行的回调函数
				  //alert('分享成功');
				},
				cancel: function () { 
				  // 用户取消分享后执行的回调函数
				}
			});
		});
		
    },
    methods: {
		msg (){
			this.msgShow =true;
			clearTimeout(this.timeOut);
			this.timeOut = setTimeout(() => {
               this.msgShow =false;
			}, 2000)
		},
		fmtMobile (data) {
            let mobile = data.substr(0,3)+'****'+data.substr(7,4);
            return mobile;
        },
		getComment () {
			this.$post('api/articlecomment',{'id': this.article_id})
			.then( res => {
				this.comment_data = res.data.data;
			})
		},
    	getData () {
    		let postData = this.$qs.stringify({
			    'cid': this.cate_id,
			    'id': this.article_id
			});
    		let url = apiUrl + 'api/detail/'
			this.$axios({
				method: 'post',
			    url: url,
			    headers: httpHead,
			    data: postData
			})
	        	.then(res => {
	        		if(res.data.code == 202){
	        			this.isArticle = false;
	        		}else{
	        			this.art_data = res.data.data;
		                this.pageSeo = res.data.data.seo;
		                setSEO(this.pageSeo)
		                this.isart_data=true
	        		}
	            })
	            .catch(err => {
	                if (err.response) {
	                    console.log(err.response)
	                }
	            })
    	},
    	wxShare () {
    		this.link = window.location.href;
    		let wxData = this.$qs.stringify({
			    'url': this.link,
			});
    		let url = apiUrl + 'wx/index'
			this.$axios({
				method: 'post',
			    url: url,
			    data: wxData
			})
	        	.then(res => {
		        	wx.config({
			  　　　　　　debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
			  　　　　　　appId: res.data.appId, // 必填，公众号的唯一标识
			  　　　　　　timestamp: res.data.timestamp, // 必填，生成签名的时间戳
			  　　　　　　nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
			  　　　　　　signature: res.data.signature,// 必填，签名，见附录1
			  　　　　　　jsApiList: [
			  　　　　　　　　 'checkJsApi',
			              'onMenuShareTimeline',
			              'onMenuShareAppMessage',
			              'onMenuShareQQ',
			              'onMenuShareWeibo',
			              'onMenuShareQZone'
			  　　　　　　] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			  　　　　　　});
		        	 wx.error(function (res) {
				  　　　	console.log(JSON.stringify(res))
				  　　});
	            })
	            .catch(err => {
	                if (err.response) {
	                    console.log(err.response)
	                }
	            })
    	},
    	formateTime (date) {
    		let time = new Date(date * 1000);
    		let fmt = 'yy-dd hh:mm'
    		if (/(y+)/.test(fmt)) {
    			let month = time.getMonth() + 1;
    			month = month < 10 ? '0' + month : month;
    			fmt = fmt.replace(RegExp.$1,month);
    		}
    		if (/(d+)/.test(fmt)) {
    			let day = time.getDate();
    			day = day < 10 ? '0' + day : day;
    			fmt = fmt.replace(RegExp.$1,day);
    		}
    		if (/(h+)/.test(fmt)) {
    			let hours = time.getHours();
    			hours = hours < 10 ? '0' + hours : hours;
    			fmt = fmt.replace(RegExp.$1,hours);
    		}
    		if (/(m+)/.test(fmt)) {
    			let minutes = time.getMinutes();
    			minutes = minutes < 10 ? '0' + minutes : minutes;
    			fmt = fmt.replace(RegExp.$1,minutes);
    		}
    		return fmt;
		},
		onSubmit () {
			if(this.comment == ''){
				this.msg();
				this.tipText = "评论内容不能为空";
				return false;
			}else if(this.comment.length>200){
				this.msg();
				this.tipText = "评论内容不能超出200";
				return false;
			}else{
				this.$post('api/comment',{'content' : this.comment,'object_id': this.article_id})
				.then( res => {
					this.msg();
					this.tipText = res.msg;
					this.comment = ''
					if(res.code == 222){
						document.cookie = "mobile=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
	                    document.cookie = "name=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
	                    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
	                    setTimeout(() => {
	                        this.$router.push({ name: 'loginView',params:{from:'detail'}})
	                    }, 2000)
					}
				})
			}
			
		}
    },
    watch: {
    	'$route' (to, from) {
		 	this.cate_id = this.$route.params.cid
    		this.article_id = this.$route.params.id
			this.getData();
			this.getComment();
    		window.scrollTo(0,0);
		}
	},
	components:{
		tip
	}
}
</script>

<style lang='scss'>
/*文章详情*/
.art-detail{
	padding-bottom:1rem;
}
.detail-content{
	padding:.3rem;
	.hd{
		margin-bottom: .5rem;
		padding-bottom: .3rem;
		border-bottom: 1px solid #e6e6e6;
		h3{
			font-size: .45rem;
			color: #333;
			font-weight: 600;
			line-height: 1.5;
			margin-bottom: .3rem;
		}
		.info{
			span{
				display: inline-block;
			    line-height: .4rem;
			    margin-right: .3rem;
			    font-size: .24rem;
			    color: #999;
			}
			.iconfont{
				font-size: .4rem;
				vertical-align: middle;
			    margin-right: .1rem;
			}
		}
	}
	.bd{
		.text-contet{
			line-height: 1.5;
			margin-bottom: .3rem;
			font-size: 16px;
			color: #333;
			video{
				max-width:100%;
			}
			.video-iframe{
				width: 100%;
				height: 3.9rem;
			}
			img{
				max-width: 100%;
				display: block;
				margin-left: auto;
				margin-right: auto;
			}
			p{
				line-height: 1.75!important;
    			margin-bottom: 15px;
    			word-break: break-all;
			}
		}
		.art-label{
			margin-bottom: .3rem;
			height: .42rem;
			line-height: .42rem;
			color: #333;
			font-size: .26rem;
			overflow: hidden;
			span{
				display: inline-block;
				padding:0 .1rem;
				background:#1a5dad;
				color: #fff;
				margin-right: .1rem;
				font-size: .24rem;
			}
		}
		.statement{
			line-height: 1.5;
			margin-top: .3rem;
		}
	}
}
.appPage .art-detail{
	margin-bottom:0;
}
.appPage .new-article{
	display: none;
}
.comments{
	background:#fff;
	border-top:1px solid #dcdcdc;
	padding:.2rem 0;
	.c-item{
		padding:.2rem .3rem;
		.col-1{
			width: .8rem;
			height: .8rem;
			margin-right: .2rem;
		}
		.user-name{
			font-size: .24rem;
			color:#5368ab;
			margin-bottom: .2rem;
		}
		.c-conten{
			font-size: .28rem;
			color:#363636;
			margin-bottom: .15rem;
			line-height:1.5;
			overflow: hidden;
		}
	}
}
.share-bar {
	position: fixed;
	bottom: .99rem;
	left:0;
	right:0;
	background: #fff;
	border-top:1px solid #f5f5f5;
	padding: .1rem .3rem;
	.text{
		margin-right:.1rem;
		font-size: .24rem;
	}
	.icon-img{
		margin-right: .15rem;
		img{
			width: .55rem;
			height: .55rem;
		}
	}
}
.share-tip-layer{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0,.6);
	z-index:99;
	img{
		position: absolute;
		bottom: .2rem;
		left: 50%;
		transform: translateX(-50%);
	}
}
.comment-submit{
	position: fixed;
	width: 100%;
	bottom: 0;
	left:0;
	height: .99rem;
	box-sizing: border-box;
	border-top:1px solid #f5f5f5;
	background:#fff;
	padding:.18rem .3rem;
	.login-btn{
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
	.input-control{
		background:#eeeeee;
		height: .64rem;
		border-radius:.32rem;
		line-height:.64rem;
		padding:0 .25rem;
		.iconfont{
			color:#aaa;
			margin-right: .2rem;
			font-size: .38rem;
		}
		input{
			border:none;
			padding:0;
			outline: none;
			background:none;
			line-height:.64rem;
		}
	}
	.sub-btn{
		border:none;
		padding:0;
		background: none;
		margin-left: .2rem;
		font-size: .28rem;
		color: #363636;
		outline: none;
	}
}
.new-article{
	padding:0 .3rem;
	.hd{
		padding-top: .1rem;
		border-bottom:1px solid #e6e6e6;
		h3{
			height: .6rem;
			line-height: .6rem;
			font-size:.3rem;
		}
		.icon{
			display: inline-block;
		    width: .28rem;
		    height: .6rem;
		    background: url("../common/images/hot-icon.png") 0 center no-repeat;
		    background-size: contain;
		    vertical-align: middle;
		    margin-right: .2rem;
		}
	}
	.bd{
		padding-top:.2rem;
		.article-item{
			width:50%;
			padding-right: .15rem;
			margin-bottom: .2rem;
			box-sizing: border-box;
			&:nth-child(2n){
				padding-right: 0;
				padding-left: .15rem;
			}
			.img-box{
				height: 2rem;
				overflow: hidden;
				text-align:center;
			}
			img{
				max-width: 100%;
			}
			.text-box{
				padding:.1rem;
				background:#f2f2f2;
			}
			.tit{
				height: .8rem;
				line-height: .4rem;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				font-size: .28rem;
				color:#333;
			}
		}
	}
}
.notArticle{
	text-align:center;
	padding:2rem 0;
	font-size:.3rem;
}
</style>


// WEBPACK FOOTER //
// src/page/detailView.vue